import { render, staticRenderFns } from "./w-input.vue?vue&type=template&id=50971154&scoped=true"
import script from "./w-input.vue?vue&type=script&lang=ts"
export * from "./w-input.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50971154",
  null
  
)

export default component.exports